module.exports = __webpack_public_path__ + "img/20231109101224553s37.b735e2ae.jpg";